const STORAGE_KEY = "incendium:smartIframeDebug";

let didAnnounce = false;

export const isSmartIframeDebugEnabled = (): boolean => {
  try {
    if (typeof window === "undefined") {
      return false;
    }
    if (localStorage.getItem(STORAGE_KEY) === "1") {
      return true;
    }
    return new URLSearchParams(window.location.search).has("smartIframeDebug");
  } catch {
    return false;
  }
};

export const smartIframeDebug = (
  scope: string,
  message: string,
  data?: unknown,
): void => {
  if (!isSmartIframeDebugEnabled()) {
    return;
  }
  if (!didAnnounce) {
    didAnnounce = true;
    console.info(
      `[SmartIframe] debug enabled. Disable with localStorage.removeItem("${STORAGE_KEY}")`,
    );
  }
  if (data !== undefined) {
    console.log(`[SmartIframe:${scope}] ${message}`, data);
    return;
  }
  console.log(`[SmartIframe:${scope}] ${message}`);
};
